import { createSlice } from "@reduxjs/toolkit"
import uz from "../../../../lang/uz"
import ru from "../../../../lang/ru"
import en from "../../../../lang/en"





export const LangOptions = [
    'ru',
    'uz',
]

const translations = {
    'ru': ru,
    'uz': uz,
    'en': en,
}

export const Translate = (lang, key, params = {}) => {
    const langTranslations = translations[lang] || {}
    let translation = langTranslations[key] || key
    const args = params || {}

    const argKeys = Object.keys(args)
    for (let i = 0; i < argKeys.length; i++) {
        const argKey = argKeys[i]
        translation = translation.replace(`{${argKey}}`, args[argKey])
    }

    return translation
}






export const mainSlice = createSlice({
    name: "main",
    initialState: {
        // temporary
        count: 6,
        lang: localStorage.getItem("Lang") || "ru",
        favorites: [],
    },
    reducers: {
        // temporary
        updateCount: (state, action) => {
            state.count = action.payload
        },
        updateLang: (state, action) => {
            state.lang = action.payload
            localStorage.setItem("Lang", action.payload)
        },
        addToFavorites: (state, action) => {
            state.favorites.push(action.payload)
        },
        removeToFavorites: (state, action) => {
            state.favorites = state?.favorites?.filter(item => item?.id !== action?.payload?.id)
        },
    },
})


export const selectCount = state => state.main.count
export const selectLang = state => state.main.lang


// favorite
export const selectFavorites = state => state.main.favorites

export const {updateCount, updateLang, addToFavorites, removeToFavorites} = mainSlice.actions

export default mainSlice.reducer